/* @flow */
import * as React from 'react';
import { Snackbar } from 'common/components/core/snackbar/index';
import { Icon } from 'common/components/core/icon';
import { connect } from 'react-redux';
import { translate, type TFunction } from 'react-i18next';
import { compose } from 'recompose';

import { acknowledgeError } from 'common/redux/actions/error';

import ErrorHandlerTheme from './ErrorHandler.scss';

type OwnProps = {
    error: Error
};

type Props = {
    ...OwnProps,
    t: TFunction,
    acknowledgeError: (error: Error) => void
};

class ErrorHandler extends React.PureComponent<Props> {
    onAcknowledge = () => {
        const { error, acknowledgeError } = this.props;
        acknowledgeError(error);
    };

    render() {
        var { error, t } = this.props;
        if (!error) return null;

        return (
            <Snackbar
                action={t('dismiss')}
                icon={<Icon icon="alert" theme={ErrorHandlerTheme} />}
                active
                theme={ErrorHandlerTheme}
                onClick={this.onAcknowledge}
                timeout={error.autoAcknowledgeTimeout}
                onTimeout={this.onAcknowledge}
                label={error.message}
            />
        );
    }
}

const ErrorHandlerContainer = (compose(
    translate('translations'),
    connect(null, { acknowledgeError })
)(ErrorHandler): React.AbstractComponent<OwnProps>);
export { ErrorHandlerContainer as ErrorHandler };
